const state = {
  isResident: '',
  shouldAskIsResident: false
};

const getters = {
  isResident: state => state.isResident,
  shouldAskIsResident: state => state.shouldAskIsResident,
  isVoterResident: state => state.isResident.toLowerCase() === 'yes'
};

const actions = {
  setShouldAskIsResident({commit}, value) {
    return commit('SET_SHOULD_ASK_IS_RESIDENT', value);
  },
  setIsResident({commit}, isResident) {
    return commit('SET_ISRESIDENT', isResident);
  },
  clearIsResident({commit}) {
    return commit('SET_ISRESIDENT', '');
  }
};

const mutations = {
  SET_ISRESIDENT(state, isResident) {
    state.isResident = isResident;
  },
  SET_SHOULD_ASK_IS_RESIDENT(state, value) {
    state.shouldAskIsResident = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/resident.js